export default "__VITE_ASSET__CFus5BZi__"